window.ourLocalStorage = (() => {
  const { localStorage } = window;

  return {
    setItem: (key, value) => {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        // Chrome errors out when accessing local storage in incognito mode. Do nothing For now
      }
    },
    getItem: (key) => {
      try {
        const value = localStorage.getItem(key);
        if (value !== '') {
          return JSON.parse(value);
        }
        return value;
      } catch (e) {
        return '';
      }
    },
  };
})();

export default window.ourLocalStorage;
